import { DownloadSimpleIcon, XIcon } from "@phosphor-icons/react";

import Button, { ButtonSize, ButtonVariant } from "@gx/dls/buttons/Button";
import Chip from "@gx/dls/chips/Chip";
import HelpIcon from "@gx/dls/icons/HelpIcon";
import Text, { TextWeight } from "@gx/dls/text/Text";
import Tooltip, { TooltipPosition } from "@gx/dls/tooltip/Tooltip";
import {
  SourceArtifactContentType,
  SourceArtifactType,
} from "@gx/ts-contracts/services/database/models/public_pb";
import { SourceArtifactResource } from "@gx/ts-contracts/services/source/resources/source_artifact_pb";

import BaseToolbar from "@/layouts/components/BaseToolbar";

import {
  SOURCE_ARTIFACT_CONTENT_TYPE_TO_FILE_EXTENSION_MAP,
  SOURCE_ARTIFACT_TYPE_TO_NAME_MAP,
} from "@/pages/sources/components/edit/tabs/artifacts/constants";

import { convertProtobufTimestampToDate, formatDateTime } from "@/utils/datetimes";

interface SourceArtifactContentViewerHeaderProps {
  artifact: SourceArtifactResource;
  onDownload: () => void;
  onClose: () => void;
}

const SourceArtifactContentViewerHeader = ({
  artifact,
  onDownload,
  onClose,
}: SourceArtifactContentViewerHeaderProps) => {
  return (
    <BaseToolbar
      leadingActions={[
        <Text key="name" weight={TextWeight.MEDIUM}>
          {SOURCE_ARTIFACT_TYPE_TO_NAME_MAP[artifact?.type ?? SourceArtifactType.UNSPECIFIED]}
        </Text>,
        <Chip
          key="content-type"
          label={`.${
            SOURCE_ARTIFACT_CONTENT_TYPE_TO_FILE_EXTENSION_MAP[
              artifact?.contentType ?? SourceArtifactContentType.UNSPECIFIED
            ]
          }`}
        />,
        <Tooltip
          key="help-tooltip"
          position={TooltipPosition.RIGHT}
          body={`This file was created on ${artifact.createdAt ? formatDateTime(convertProtobufTimestampToDate(artifact.createdAt).toISOString()) : "—"}`}
        >
          <HelpIcon />
        </Tooltip>,
      ]}
      trailingActions={[
        <Button
          key="download"
          label="Download"
          icon={DownloadSimpleIcon}
          variant={ButtonVariant.TERTIARY}
          size={ButtonSize.SMALL}
          onClick={onDownload}
        />,
        <Button
          key="close"
          icon={XIcon}
          variant={ButtonVariant.TERTIARY}
          size={ButtonSize.SMALL}
          onClick={onClose}
        />,
      ]}
    />
  );
};

export default SourceArtifactContentViewerHeader;
